enum MessageOriginType {
  RECEIVER = 'RECEIVER',
  SENDER = 'SENDER',
}
export default MessageOriginType
